import { memo } from 'react';
import { Box, Button, Image, Text } from '@bonanza-social/moonlight';
import { BottomSheetExtendedProps } from '@bonanza-social/navigation';

function ScreenNameInfoBottomSheet({ close }: BottomSheetExtendedProps) {
  return (
    <Box>
      <Image
        name="account.ScreenName"
        resizeMode="contain"
        width={64}
        height={80}
        alignSelf="center"
      />
      <Text
        variant="h5"
        color="darkSurfacePrimary"
        locNS="account"
        locKey="screenName"
        textAlign="center"
        marginVertical="space-400"
      />
      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        locNS="account"
        locKey="screenNameInfo"
        textAlign="center"
      />
      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        locNS="account"
        locKey="screenNameDescription"
        textAlign="center"
        marginVertical="space-400"
      />
      <Button
        variant="primary"
        onPress={close}
        locNS="account"
        locKey="gotIt"
      />
    </Box>
  );
}

export default memo(ScreenNameInfoBottomSheet);
